module.exports = "/static/videos/lake_optimized.mp4";